<app-header [showSlider]="false" [navLight]="false"></app-header>
<br>
<br>
<br>
<br>

<!-- <div class="container" id="pricing"> -->
<!-- <div class="text-center mx-auto" style="max-width: 600px;">
        <h1 class="display-5">Pricing Calculations</h1>
        <hr class="w-25 mx-auto bg-primary">
    </div>

    <div class="container">
        <div class="count-section">
            <div class="count-field">
                <label for="studentCount">No of Students:</label>
                <input type="number" id="studentCount" [(ngModel)]="studentCount"
                    (ngModelChange)="onStudentCountChange()" min="0" class="count-input">
            </div>
            <div class="count-field">
                <label for="teacherCount">No of Teachers:</label>
                <input type="number" id="teacherCount" [(ngModel)]="teacherCount"
                    (ngModelChange)="onTeacherCountChange()" min="0" class="count-input">
            </div>
        </div>

        <div class="table-container">
            <table class="plans-table">
                <thead>
                    <tr>
                        <th>Plan</th>
                        <th>Type</th>
                        <th>Price</th>
                        <th>Used</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let plan of plans" [class.selected]="plan.used">
                        <td data-label="Plan">{{ plan.response.text_1753252798908_50663 }}</td>
                        <td data-label="Type">
                            <span
                                [class]="plan.response.dropdown_1753278552800_61101 === 'Student Based' ? 'type-student' : (plan.response.dropdown_1753278552800_61101 === 'Staff Based' ? 'type-teacher' : (plan.response.dropdown_1753278552800_61101 === 'Static' ? 'type-static' : 'type-static'))">
                                {{ plan.response.dropdown_1753278552800_61101 }}
                            </span>
                        </td>
                        <td data-label="Price">₹{{ plan.response.number_1753252916954_68847 }}</td>
                        <td data-label="Used">
                            <input type="checkbox" [checked]="plan.used" (change)="onCheckboxChange(plan)"
                                class="checkbox">
                        </td>
                        <td data-label="Total">
                            <span *ngIf="plan.used && plan.response.dropdown_1753278552800_61101 === 'Student Based'">
                                ₹{{ plan.response.number_1753252916954_68847 * studentCount }}
                            </span>
                            <span
                                *ngIf="plan.used && (plan.response.dropdown_1753278552800_61101 === 'Teacher Based' || plan.response.dropdown_1753278552800_61101 === 'Staff Based')">
                                ₹{{ plan.response.number_1753252916954_68847 * teacherCount }}
                            </span>
                            <span *ngIf="plan.used && plan.response.dropdown_1753278552800_61101 === 'Static'">
                                ₹{{ plan.response.number_1753252916954_68847 }}
                            </span>
                            <span *ngIf="plan.used && !plan.response.dropdown_1753278552800_61101">
                                ₹{{ plan.response.number_1753252916954_68847 }}
                            </span>
                            <span *ngIf="!plan.used">-</span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="total-row">
                        <td colspan="4" class="total-label">Grand Total:</td>
                        <td class="total-amount">₹{{ getGrandTotal() }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <div class="summary-section">
            <span>
                <div class="summary-item">
                    <span class="summary-label">Student Plans Total:</span>
                    <span class="summary-amount">₹{{ getStudentTotal() }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Teacher/Staff Plans Total:</span>
                    <span class="summary-amount">₹{{ getTeacherTotal() }}</span>
                </div>
                <div class="summary-item">
                    <span class="summary-label">Static Plans Total:</span>
                    <span class="summary-amount">₹{{ getStaticTotal() }}</span>
                </div>
            </span>
            <div class="summary-item total-summary">
                <span class="summary-label">Grand Total:</span>
                <span class="summary-amount">₹{{ getGrandTotal() }}</span>
            </div>
        </div>
    </div> -->

<!-- /////////////////////// -->
<div class="container">
    <div class="count-section">
        <div class="count-field">

            <div class="table-container">
                <table class="plans-table">
                    <thead>
                        <tr>
                            <th>Plan</th>
                            <th>Type</th>
                            <th>Price</th>
                            <th>Used</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let plan of plans" [class.selected]="plan.used">
                            <td data-label="Plan" style="color: #000;">
                            {{ plan.plan }}
                            </td>

                            <td data-label="Type">
                            <span
                                [class]="
                                plan.type === 'Student Based'
                                    ? 'type-student'
                                    : plan.type === 'Staff Based'
                                    ? 'type-teacher'
                                    : 'type-static'
                                "
                            >
                                {{ plan.type }}
                            </span>
                            </td>

                            <td data-label="Price" style="color: #000;">
                            ₹{{ plan.price }}
                            </td>

                            <td data-label="Used">
                            <input
                                type="checkbox"
                                [checked]="plan.used"
                                (change)="onCheckboxChange(plan)"
                                class="checkbox"
                            >
                            </td>

                            <td data-label="Total" style="color: #000;">
                            <ng-container *ngIf="plan.used; else unused">
                                <span *ngIf="plan.type === 'Student Based'">
                                ₹{{ plan.price * studentCount }}
                                </span>

                                <span
                                *ngIf="
                                    plan.type === 'Staff Based' ||
                                    plan.type === 'Teacher Based'
                                "
                                >
                                ₹{{ plan.price * teacherCount }}
                                </span>

                                <span *ngIf="plan.type === 'Static'">
                                ₹{{ plan.price }}
                                </span>
                            </ng-container>

                            <ng-template #unused>-</ng-template>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="total-row">
                            <td colspan="4" class="total-label">Grand Total:</td>
                            <td class="total-amount">₹{{ getGrandTotal() }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <div class="count-field">
            <div class="input-row">
                <div>
                    <label for="studentCount">No of Students:</label>
                    <input type="number" id="studentCount" [(ngModel)]="studentCount"
                        (ngModelChange)="onStudentCountChange()" min="0" class="count-input">
                </div>
                <div>
                    <label for="teacherCount">No of Teachers:</label>
                    <input type="number" id="teacherCount" [(ngModel)]="teacherCount"
                        (ngModelChange)="onTeacherCountChange()" min="0" class="count-input">
                </div>
            </div>

            <div style="margin-top: 20px;">
                <div class="summary-section">
            <div class="summary-item">
                <span class="summary-label">Per Student:</span>
                <!-- <span class="summary-amount">₹{{ getStudentTotal() | thousandShort }}</span> -->
                <span class="summary-amount">₹{{ getIndStudentTotal() }}</span>
            </div>
            </div></div>

            <div style="margin-top: 20px;">
                <div class="summary-section">
                    <span>
                        <div class="summary-item">
                            <span class="summary-label">Student Plans Total:</span>
                            <span class="summary-amount">₹{{ getStudentTotal() }}</span>
                        </div>
                        <div class="summary-item">
                            <span class="summary-label">Teacher/Staff Plans Total:</span>
                            <span class="summary-amount">₹{{ getTeacherTotal() }}</span>
                        </div>
                        <div class="summary-item">
                            <span class="summary-label">Static Plans Total:</span>
                            <span class="summary-amount">₹{{ getStaticTotal() }}</span>
                        </div>
                    </span>
                    <div class="summary-item total-summary">
                        <span class="summary-label">Grand Total:</span>
                        <span class="summary-amount">₹{{ getGrandTotal() }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- </div> -->



<!-- <main>

    
    <div class="content-grid">

        <section class="plan-section">
            <div class="plan-section-header">
                <h2>Plan Customization</h2>
                <span>Updated Daily</span>
            </div>

            <div class="plan-table-wrap">
                <table class="plan-table">
                    <thead>
                        <tr>
                            <th style="font-weight: 400;">Plan</th>
                            <th class="center" style="font-weight: 400;">Type</th>
                            <th class="right" style="font-weight: 400;">Price</th>
                            <th class="center" style="font-weight: 400;">Used</th>
                            <th class="right" style="font-weight: 400;">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="plan-name">Administration</div>
                                <div class="plan-sub">Core management</div>
                            </td>
                            <td class="td-center"><span class="badge badge-student">Student Based</span></td>
                            <td class="td-right price-cell">$2.50</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" checked /></td>
                            <td class="td-right total-active">$2,500.00</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="plan-name">Attendance</div>
                                <div class="plan-sub">Digital tracking</div>
                            </td>
                            <td class="td-center"><span class="badge badge-student">Student Based</span></td>
                            <td class="td-right price-cell">$1.20</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" checked /></td>
                            <td class="td-right total-active">$1,200.00</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="plan-name">Staff Attendance</div>
                                <div class="plan-sub">Employee clock-in</div>
                            </td>
                            <td class="td-center"><span class="badge badge-staff">Staff Based</span></td>
                            <td class="td-right price-cell">$5.00</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" checked /></td>
                            <td class="td-right total-active">$250.00</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="plan-name">Exam</div>
                                <div class="plan-sub">Automated grading</div>
                            </td>
                            <td class="td-center"><span class="badge badge-student">Student Based</span></td>
                            <td class="td-right price-cell">$1.80</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" /></td>
                            <td class="td-right total-inactive">$0.00</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="plan-name">Website</div>
                                <div class="plan-sub">Custom portal</div>
                            </td>
                            <td class="td-center"><span class="badge badge-static">Static</span></td>
                            <td class="td-right price-cell">$299.00</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" checked /></td>
                            <td class="td-right total-active">$299.00</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="plan-name">Social Media</div>
                                <div class="plan-sub">Marketing tool</div>
                            </td>
                            <td class="td-center"><span class="badge badge-static">Static</span></td>
                            <td class="td-right price-cell">$150.00</td>
                            <td class="td-center"><input type="checkbox" class="plan-check" /></td>
                            <td class="td-right total-inactive">$0.00</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="plan-footer">
                <p>Monthly pricing. Annual billing: 15% discount.</p>
                <button class="btn-all-modules">
                    All Modules
                    <span class="material-symbols-outlined">arrow_forward</span>
                </button>
            </div>
        </section>

        <aside class="right-col">


            <div class="metrics-card">
                <h3>
                    <span class="material-symbols-outlined">analytics</span>
                    Metrics
                </h3>
                <div class="metrics-grid">
                    <div class="metric-field">
                        <label>Students</label>
                        <div class="input-wrap">
                            <input type="number" value="1000" />
                            <span class="material-symbols-outlined input-icon">groups</span>
                        </div>
                    </div>
                    <div class="metric-field">
                        <label>Teachers</label>
                        <div class="input-wrap">
                            <input type="number" value="50" />
                            <span class="material-symbols-outlined input-icon">person_pin</span>
                        </div>
                    </div>
                </div>
            </div>


            <div class="summary-card" style="color: #000; font-family: Verdana, Geneva, Tahoma, sans-serif; font-size: 5px;">
                <div class="summary-body">
                    <h3>Financial Summary</h3>
                    <div class="summary-rows">
                        <div class="summary-row">
                            <span class="row-label">Student Based</span>
                            <span class="row-value">$3,700.00</span>
                        </div>
                        <div class="summary-row">
                            <span class="row-label">Teacher/Staff</span>
                            <span class="row-value">$250.00</span>
                        </div>
                        <div class="summary-row">
                            <span class="row-label">Static Plans</span>
                            <span class="row-value">$299.00</span>
                        </div>
                        <div class="summary-divider">
                            <div class="summary-row">
                                <span class="row-label">Platform Fee</span>
                                <span class="row-value">$49.00</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grand-total">
                    <div class="grand-total-bg-icon">
                        <span class="material-symbols-outlined">payments</span>
                    </div>
                    <div class="grand-total-inner">
                        <span class="grand-total-label">Grand Total</span>
                        <div class="grand-total-amount">
                            <span class="dollar">$</span>
                            <span class="amount">4,298.00</span>
                            <span class="period">/mo</span>
                        </div>
                        <p class="grand-total-note">Taxes included. Terms apply.</p>
                    </div>
                </div>

                <button class="btn-cta">Generate PDF Quote</button>
            </div>

        </aside>
    </div>
</main> -->

<app-footer></app-footer>